import {
  Box,
  Button,
  Drawer,
  FormControlLabel,
  Grid,
  IconButton,
  Skeleton,
  Radio,
  RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Cookies, withCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import { rem, setCookiesSync } from "assets/js/common";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import Routes from "routes/Routes";
import _ from "lodash";
import Left from "components/ui/Left";
import GuideLeft from "components/ui/guide/Left";
import AlertConfirm from "./alert-confirm";
import { setBottomColor, exitApp, setAppData } from "assets/js/apphandle";
import { loadAlert, loadFavAlert } from "redux/reducers/top";
import { loadMainAction } from "redux/reducers/home";
import { initTop } from "redux/reducers/top";
import FavoriteStoreDrawer from "./favorite-store-drawer";
import CacheRoute, {
  dropByCacheKey,
  getCachingKeys,
  clearCache,
} from "react-router-cache-route";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
    padding: `0 ${rem(20)}`,
    "& .MuiIconButton-root": {
      width: rem(30),
      height: rem(30),
    },
    "& .btn-back": {
      backgroundImage: `url(${
        process.env.PUBLIC_URL
      }/images/icon/back-header.svg)`,
    },
    "& .btn-menu": {
      backgroundImage: `url(${
        process.env.PUBLIC_URL
      }/images/icon/menu-header.svg)`,
      marginLeft: rem(10),
    },
    "& .h2": {
      marginBottom: rem(2),
    },

    "& .main-top": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      "& .main-tp": {
        paddingLeft: rem(10),
        "& .dropdown-icon": {
          paddingLeft: rem(4),
        },
      },
      "& .fav-store": {
        position: "relative",
        fontSize: rem(13),
        fontWeight: 400,
        lineHeight: rem(20),
        margin: 0,
        paddingLeft: rem(20),
        minWidth: "auto",
        "&::after": {
          content: "''",
          position: "absolute",
          top: rem(0),
          left: rem(0),
          width: rem(20),
          height: rem(20),
          backgroundImage: `url(${
            process.env.PUBLIC_URL
          }/images/icon/location.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },
      },
    },
  },
}));

function Top(props) {
  let cookies = new Cookies();

  const history = useHistory();
  const classes = useStyles();

  let cookieExpires = new Date();
  cookieExpires.setDate(cookieExpires.getDate() + 180);

  let favInfo = cookies.get("favInfo");
  const [token, setToken] = useState("");
  const [visibleTp, setVisibleTp] = useState(
    favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1
  );

  const { topState } = useSelector((state) => state.top);

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [sidebar, setSidebar] = useState(false);
  const [guideSidebar, setGuideSidebar] = useState(false);
  const handleSidebarOpen = () => {
    location.pathname.indexOf("guide") != -1
      ? setGuideSidebar(true)
      : setSidebar(true);
  };

  const handleSidebarClose = () => {
    location.pathname.indexOf("guide") != -1
      ? setGuideSidebar(false)
      : setSidebar(false);
    dropByCacheKey(location.pathname);
  };

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState(favInfo ? favInfo.visibleTp : 1);
  const [storeList, setStoreList] = useState([]);
  const [redirectPath, setRedirectPath] = useState("");
  const [open, setOpen] = useState(false);
  const [favOpen, setFavOpen] = useState(false);
  const dispatch = useDispatch();

  const changeMainTp = (tp) => {
    setCookiesSync("favInfo", { ...favInfo, visibleTp: tp });
    // cookies.set(
    //   "favInfo",
    //   { ...favInfo, visibleTp: tp },
    //   {
    //     path: "/",
    //     expires: cookieExpires,
    //   }
    // );

    setVisibleTp(tp);

    let storeCode = favInfo
      ? favInfo.visibleTp == "1"
        ? favInfo.favMt
        : favInfo.favMk
      : "";

    dispatch(
      loadMainAction({
        schTp: tp,
        schStore: favInfo ? (tp == "1" ? favInfo.favMt : favInfo.favMk) : "",
      })
    );

    window.scrollTo(0, 0);
  };

  const loadStoreList = () => {
    let store = "";
    axios
      .get(`/api/st/store-code`, {
        params: {
          tp: "",
          useYn: "Y",
        },
      })
      .then((res) => {
        if (res.data.data) setStoreList(res.data.data);
      });
    return store;
  };

  const getStoreNm = () => {
    let cd = favInfo
      ? favInfo.visibleTp == "1"
        ? favInfo.favMt
        : favInfo.favMk
      : "";

    if (!cd) return "단골매장";

    let find = storeList.find((store) => store.cd == cd);
    return find ? find.nm : "";
  };

  useEffect(() => {
    if (!favInfo) {
      setVisibleTp(1);
      setDrawerData(1);
    } else {
      if (drawerData !== favInfo.visibleTp) setDrawerData(favInfo.visibleTp);
      //   handleMainTp();
    }
  }, [favInfo && favInfo.visibleTp]);

  useEffect(() => {
    loadStoreList();
  }, []);

  useEffect(() => {
    if (
      location.pathname !== "/" ||
      sidebar === true ||
      drawerOpen === true ||
      favOpen === true
    ) {
      setBottomColor("FFFFFF");
    } else setBottomColor("F1270B");
  }, [sidebar, drawerOpen, favOpen]);

  useEffect(() => {
    if (topState.main === false && location.pathname !== "/") {
      setBottomColor("FFFFFF");
    } else {
      setBottomColor("F1270B");
    }
  }, [topState]);

  const goPage = (path) => {
    const cookieToken = cookies.get("X-REFRESH-TOKEN");
    if (cookieToken) {
      let cd = favInfo
        ? favInfo.visibleTp == "1"
          ? favInfo.favMt
          : favInfo.favMk
        : "";
      if (cd) setFavOpen(true);
      else dispatch(loadFavAlert(true));
      // history.push(path);
    } else {
      dispatch(loadAlert(true));
    }
  };

  const handleAlertOpen = (path) => {
    setRedirectPath(path);
    setOpen(true);
  };

  const handleAlertClose = () => {
    // setOpen(false);
    dispatch(loadAlert(false));
  };

  const handleDrawerFavClose = () => {
    setFavOpen(false);
  };

  const historyBack = () => {
    dispatch(initTop(true));
    if (history.action == "REPLACE") {
      history.push("/");
    } else if (
      history.action == "POP" &&
      location.pathname.indexOf("/membership/") > -1
    ) {
      history.replace("/");
    } else if (
      history.action == "POP" &&
      location.pathname.indexOf("/event/") > -1
    ) {
      history.replace("/");
    }
    // else if (location.pathname.indexOf("/event/") > -1) {
    //   history.replace("/event");
    //   // } else if (
    //   //   history.action == "POP" &&
    //   //   location.pathname.indexOf("/membership/") > -1
    //   // ) {
    //   //   history.replace("/");
    // }
    else {
      history.goBack();
    }
  };

  const handleMainTp = (value) => {
    console.log("value: ", value);
    if (value) setDrawerData(value);
    // else {
    //   setVisibleTp(favInfo.visibleTp);
    //   setDrawerData(favInfo.visibleTp);
    // }
  };

  useEffect(() => {
    window.appBackKeyHandle = () => {
      if (drawerOpen) {
        setDrawerOpen(false);
      } else if (favOpen) {
        handleDrawerFavClose();
      } else if (!drawerOpen || !favOpen) {
        exitApp();
      }
    };

    if (drawerOpen === true) setDrawerData(favInfo ? favInfo.visibleTp : "1");
  }, [drawerOpen, favOpen]);

  return (
    <>
      <header className={classes.header}>
        {topState.back ? (
          <IconButton
            aria-label="back"
            className="btn-back"
            size="small"
            onClick={historyBack}
          >
            <span className="hidden">이전</span>
          </IconButton>
        ) : (
          <IconButton
            aria-label="hidden"
            size="small"
            style={{ display: topState.main ? "none" : "" }}
          >
            <span className="hidden" />
          </IconButton>
        )}
        {topState.main ? (
          <>
            <div className="main-top">
              <Button
                className="main-tp"
                onClick={() => {
                  setDrawerOpen(true);
                }}
              >
                {favInfo && favInfo.visibleTp == "2" ? (
                  <>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icon/mk_logo.svg`}
                    />
                    <img
                      className="dropdown-icon"
                      src={`${
                        process.env.PUBLIC_URL
                      }/images/icon/dropdown-icon-yellow.svg`}
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icon/logo_red.svg`}
                    />
                    <img
                      className="dropdown-icon"
                      src={`${
                        process.env.PUBLIC_URL
                      }/images/icon/dropdown-icon-red.svg`}
                    />
                  </>
                )}
              </Button>
              <Button
                className="fav-store"
                onClick={() => {
                  goPage("/favorite-store");
                }}
              >
                {getStoreNm()}
              </Button>
            </div>
            <FavoriteStoreDrawer
              favOpen={favOpen}
              handleDrawerFavClose={handleDrawerFavClose}
              cd={
                favInfo
                  ? favInfo.visibleTp == "1"
                    ? favInfo.favMt
                    : favInfo.favMk
                  : ""
              }
            />
          </>
        ) : (
          <></>
        )}

        {topState.title ? (
          <h2 className="h2">{topState.title}</h2>
        ) : (
          <></>
          // <Skeleton height={40} width={100} />
        )}

        {topState.menu ? (
          <IconButton
            aria-label="menu"
            size="small"
            className="btn-menu"
            onClick={handleSidebarOpen}
          >
            <span className="hidden">메뉴</span>
          </IconButton>
        ) : (
          <IconButton aria-label="hidden" size="small">
            <span className="hidden" />
          </IconButton>
        )}
      </header>
      <Left
        sidebar={sidebar}
        setSidebar={setSidebar}
        handleSidebarClose={handleSidebarClose}
      />
      <GuideLeft sidebar={guideSidebar} setSidebar={setGuideSidebar} />

      {/* ST : Drawer-row */}
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
        }}
        className="drawer-common-bottom size-small"
      >
        <div className="drawer-head">
          <h3>선택</h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={() => {
              setDrawerOpen(false);
            }}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box className="box-type-10">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={drawerData}
              value={drawerData}
              name="radio-buttons-group"
              onChange={(e) => {
                handleMainTp(e.target.value);
              }}
            >
              <FormControlLabel
                value="1"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="메가마트"
              />
              <FormControlLabel
                value="2"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="메가마켓"
              />
            </RadioGroup>
          </Box>
        </div>
        <div className="drawer-foot">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              changeMainTp(drawerData);
              setDrawerOpen(false);
            }}
          >
            선택완료
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-row */}
    </>
  );
}

export default Top;
